const CMTPAX_UPDATED = (state, Cmtpax) => {
  state.Cmtpax = Cmtpax
}
const CHECKSERVICES_UPDATED = (state, CheckServices) => {
  state.CheckServices = CheckServices
}

const PAXSGROUP_UPDATED = (state, PaxsGroup) => {
  state.PaxsGroup = PaxsGroup
}

const SERVICES_UPDATED = (state, Services) => {
  state.Services = Services
  state.monetaryService = _.first(
    _.filter(Services, function (s) {
      return s.service_id == 21
    })
  )
}

const MONETARY_UPDATE = (state, monetaryService) => {
  state.monetaryService = monetaryService
}

const OVERNIGHTSTATION_UPDATED = (state, OverNightStation) => {
  state.OverNightStation = OverNightStation
}
export default {
  CMTPAX_UPDATED,
  CHECKSERVICES_UPDATED,
  PAXSGROUP_UPDATED,
  SERVICES_UPDATED,
  MONETARY_UPDATE,
  OVERNIGHTSTATION_UPDATED
}
